export var GENERIC_ERROR = 'GENERIC_ERROR';
export function genericError(error, thunk) {
  return {
    type: GENERIC_ERROR,
    payload: error,
    error: true,
    meta: {
      thunk: thunk
    }
  };
}

export var GENERIC_RESPONSE = 'GENERIC_RESPONSE';
export function genericResponse() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var thunk = arguments[1];

  return {
    type: GENERIC_RESPONSE,
    payload: payload,
    meta: {
      thunk: thunk
    }
  };
}